define('uikit/modules/instant.notification',['require','exports','module','underscore','marionette','../elements/button','../mixins/component.mixin','../templates'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var ButtonView     = require('../elements/button');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates      = require('../templates');

  var DEFAULT_TIMEOUT = 5000;

  var InstantNotificationActions = Mn.CollectionView.extend({
    className: 'ui vertical buttons',

    childView: ButtonView,

    childViewEventPrefix: 'action',

    childViewOptions: {
      bindings: {
        text: 'text',
        color: 'color',
        link: 'link',
        icon: 'icon',
        inline: 'inline',
        basic: 'basic'
      }
    }
  });

  var InstantNotification = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui raised fitted segment notification',

    template: Templates.UIKit['instant.notification'],

    options: {
      autoClose: true,
      title: '',
      details: '',
      actions: null,
      timeout: DEFAULT_TIMEOUT
    },

    forceUpdate: {
      autoClose: true,
      title: true,
      details: true,
      actions: true,
      timeout: true
    },

    // Bindings are hard coded, since notifications are data driven by frontend
    bindings: {
      title: 'title',
      details: 'details',
      secondaryAction: 'secondaryAction'
    },

    attributes: {
      style: 'display: none;'
    },

    ui: {
      'actions'       : '.actions',
      'content'       : '.content',
      'content-text'  : '.content .ui.header'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this._actions = new Backbone.Collection([]);
    },

    getActions: function() {
      var actions = this._actions;

      actions.reset([]);

      // Default close action
      actions.push({
        color: 'secondary',
        icon: 'close',
        inline: true
      });

      if (this.getOption('secondaryAction')) {
        actions.push(this.getOption('secondaryAction'));
      }

      return actions;
    },

    onRender: function() {
      var self = this;

      this.renderActions();

      _.defer(function() {
        self.show({ force: true, animation: 'slide down' });
      });
    },

    onShow: function() {
      var self = this;

      if (this.getOption('autoClose')) {
        setTimeout(function() {
          if (self.visible) {
            self.close();
          }
        }, this.getOption('timeout'));
      }
    },

    hide: function(options) {
      var self = this;

      options = _.extend({
        animation: 'slide down',
        onComplete: function() {
          self.triggerMethod('animate:complete');
        }
      }, options);

      return ComponentMixin.hide.call(this, options)
    },

    close: function() {
      var self = this;

      this.hide({
        onComplete: function() {
          self.triggerMethod('close');
        }
      });
    },

    renderActions: function() {
      var self    = this;
      var actions = new InstantNotificationActions({ collection: this.getActions() });

      this.ui.actions.html(actions.$el);

      actions.render();

      // Listen to button press, and trigger method based on the action name
      actions.on('action:press', function(a) {
        var action = a.model.get('action');

        if (action) { self.triggerMethod(action); }

        self.close();
      })
    }
  });

  var InstantNotificationModel = Backbone.Model.extend({
    defaults: {
      autoClose: true,
      icon: null,
      iconColor: 'white',
      title: '',
      details: '',
      secondaryAction: null
    }
  });

  InstantNotification.Model = InstantNotificationModel;

  module.exports = InstantNotification;
});

